export default "__VITE_ASSET__GA2RkUqT__"